import script from "./AssetTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetTable.vue?vue&type=script&setup=true&lang=js"

import "./AssetTable.vue?vue&type=style&index=0&id=5ed7cbbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed7cbbd"]])

export default __exports__